import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField'
import { IMLotLookupLayout } from '../../../../../common/lookups/Layouts/ImLayouts';
import { PrimaryLayout } from '../Layout';
import ValidationSummary from 'devextreme-react/validation-summary';
import DataSource from "devextreme/data/data_source";
import { createStore } from 'devextreme-aspnet-data-nojquery';

function PrimaryTab(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    // const formRefs = useRef({});
    const [lotLayout, setLotLayout] = useState(() =>
        IMLotLookupLayout({ rItem: props.formFields?.R_ITEM || '' })
    );
    const combinedLayouts = [
        { name: 'PrimaryLayout', layout: PrimaryLayout },
    ];
    const [formKey, setFormKey] = useState(0);
    const finalLayout = useMemo(() => {
        return PrimaryLayout(lotLayout);
    }, [lotLayout]);
    const handleSelectionChange = useCallback((name, value, e) => {
        // if (name === "R_ITEM" && value) {
        //     const newLayout = IMLotLookupLayout({ rItem: value });
        //     setLotLayout(newLayout);
        // }
        // props.handleFieldChange(name, value,e);
        props.handleFieldChange(name, value,e);
    }, []);
    useEffect(() => {
        setFormKey(prev => prev + 1);
    }, [lotLayout]);
    const loadCustomerDataSource = useCallback(() => {
        const accessToken = props.oidc?.user?.access_token;
        if (!accessToken) return null;

        const dataSourceDB = new DataSource({
            store: new createStore({
                key: 'rowid',
                loadParams: {
                    consigneeAttached: function () {
                        return props.oidc?.user?.profile?.CONSIGNEEATTACHED || false;
                    },
                    shipperAttached: function () {
                        return props.oidc?.user?.profile?.SHIPPERATTACHED || false;
                    }
                },
                loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetCustomerLookupPaging`,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });
        return dataSourceDB;
    }, [props.oidc]);

    const handlePrimaryFormLoad = useCallback(() => {
        props.primaryFormLookupsLoad();
        
        // Load customer data source for R_IDENTITY field
        const customerDataSource = loadCustomerDataSource();
        if (customerDataSource && props.formRefs?.current?.["R_IDENTITY"]) {
            const identityInstance = props.formRefs.current["R_IDENTITY"]?.instance?.();
            if (identityInstance) {
                identityInstance.option('dataSource', customerDataSource);
                identityInstance.option('valueExpr', 'rowid');
                identityInstance.option('displayExpr', 'identityId');
                identityInstance.option('searchEnabled', true);
                identityInstance.option('searchMode', 'contains');
                
                // Set the value if it exists in formFields
                if (props.formFields?.R_IDENTITY) {
                    identityInstance.option('value', props.formFields.R_IDENTITY);
                }
            }
        }
    }, [props.primaryFormLookupsLoad, loadCustomerDataSource, props.formRefs, props.formFields]);
    
    useEffect(() => {
        // Set up customer data source when form refs are available
        if (props.formRefs?.current?.["R_IDENTITY"]) {
            const customerDataSource = loadCustomerDataSource();
            if (customerDataSource) {
                // Use a small delay to ensure the SelectBox is fully initialized
                setTimeout(() => {
                    const identityInstance = props.formRefs.current["R_IDENTITY"]?.instance?.();
                    if (identityInstance) {
                        identityInstance.option('dataSource', customerDataSource);
                        identityInstance.option('valueExpr', 'rowid');
                        identityInstance.option('displayExpr', 'identityId');
                        identityInstance.option('searchEnabled', true);
                        identityInstance.option('searchMode', 'contains');
                        
                        // Set the value if it exists in formFields
                        if (props.formFields?.R_IDENTITY) {
                            identityInstance.option('value', props.formFields.R_IDENTITY);
                        }
                    }
                }, 100);
            }
        }
    }, [props.formRefs, props.formFields?.R_IDENTITY, loadCustomerDataSource]);

    return (
        <div>
            <FormField
                key={formKey}
                currrentUser={currentUser}
                layoutId='43ba2581-957c-458f-80b0-8d463fd1d3b4'
                layoutName='WMItemDataEntryPrimaryForm'
                defaultFormSchema={finalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleSelectionChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handlePrimaryFormLoad}
                handleSelectedItemChange={handleSelectionChange}
            />
            <div className="row" style={{paddingLeft: '15px'}}>
                <ValidationSummary id="summary" />
            </div>
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(PrimaryTab);
